import React from 'react';

const PrivacyPolicyPage = () => {
  return <div>Privacy Policy goes here.</div>;
};

export default PrivacyPolicyPage;
